<template>
  <div class="department_list">
    <div class="response_table">
      <div v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>

      <table v-else>
        <thead>
          <tr>
            <th scope="col"> {{ translate('diadoc.departments.name') }} </th>
            <th scope="col"> {{ translate('diadoc.departments.abbreviation') }} </th>
            <th scope="col"> {{ translate('diadoc.departments.parent_department_id') }} </th>
          </tr>
        </thead>
        <tbody>
          <tr
              class="department_item pointer"
              v-for="(department,key) in departments"
              :key="key"
          >
            <td class="text-left" :data-label="translate('diadoc.departments.name')"> {{ department.name }} </td>
            <td class="text-left" :data-label="translate('diadoc.departments.abbreviation')"> {{ department.abbreviation }} </td>
            <td :data-label="translate('diadoc.departments.parent_department_id')"> {{ department.parent_department_id }} </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DiadocDepartments',
  props:{
    departments: Array,
  },
  components: {
  },
  data () {
    return {
      loading: false,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },
}
</script>

<style lang="scss" scoped>
  .department_list {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    .header{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 10px;
      .buttons{
        span{
          display: flex;
          gap: 5px;
        }
      }
    }

    .response_table{
      //padding: 10px 0 0;
      padding: 0;
      tbody{
        tr{
          font-size: 12px;
          &:hover{
            background-color: #eeeeee;
          }
        }

        .text-left{
          text-align: left;
        }

        .limit{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.5em;
          max-height: 3em;
          margin-bottom: 0;
          font-size: 12px;
        }
      }
    }
  }
</style>
